import store from 'source/store';
import OverviewPageGroup from 'source/pages/root/OverviewPageGroup.vue';

function checkUserAccess(to, from, next) {
    const employmentLocked = store.state.auth.user?.user_profile?.is_locked;
    const workforces = store.state.auth.user.user_profile.workforce_ids;
    const isWorkforceMember = workforces.includes(parseInt(to.params?.workforce_id));
    const isOverview = to.name.includes('overview');
    const isScreenshotActivities = to.name === 'screenshots-activities';
    const user_profile = store.state.auth.user.user_profile;
    const isOrgExecutive = user_profile?.is_organizational_exec;
    const canAccess = isOrgExecutive || (isWorkforceMember && !employmentLocked);

    if ( isScreenshotActivities || (isOverview && canAccess)) {
        next();
    } else {
        next({ name: 'access-denied' });
    }
}

export default [{
    //Passing user id for org exec since org execs dont have an employment
    path: 'overview/:employment_id',
    component: OverviewPageGroup,
    props: true,
    beforeEnter: checkUserAccess,
    meta: {
        title: 'Home - HQZen',
        canDisplayGlobalModals: true
    },
    children: [{
        path: '',
        name: 'overview',
        component: () => import('source/pages/overview/OverviewPage.vue'),
        meta: {
            title: 'Home - HQZen',
            canDisplayGlobalModals: true,
            isInternal: true
        }
    }, {
        path: 'executive',
        name: 'overview-executive',
        component: () => import('source/pages/overview/OverviewManagerAndSupervisorPage.vue'),
        meta: {
            title: 'Home - HQZen',
            canDisplayGlobalModals: true,
            isInternal: true
        }
    }, {
        path: 'incident-reports',
        name: 'overview-incident-reports',
        component: () => import('source/pages/overview/OverviewIncidentReportsPage.vue'),
        meta: {
            title: 'Incident Reports - HQZen',
            canDisplayGlobalModals: true,
            isInternal: true
        },
    }, {
        path: 'incident-reports/department/:id',
        name: 'overview-incident-reports-department',
        component: () => import('source/pages/overview/OverviewDepartmentIRPage.vue'),
        meta: {
            title: 'Department Incident Reports - HQZen',
            canDisplayGlobalModals: true,
            isInternal: true
        },
    }, {
        path: 'screenshots-and-activities',
        name: 'screenshots-activities',
        component: () => import('source/pages/overview/OverviewScreenshotAndActivitiesPage.vue'),
        meta: {
            title: 'Home - HQZen',
            canDisplayGlobalModals: true,
            isInternal: true
        }
    },{
        path: 'overview-attendance',
        name: 'overview-attendance',
        component: () => import('source/pages/overview/OverviewAttendancePage.vue'),
        meta: {
            title: 'Overviews - HQZen',
            canDisplayGlobalModals: true,
            isInternal: true
        }
    }]
}];
